import { createFileRoute, ErrorComponent } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'


import { NoPermissionError } from '@/api/NoPermissionError'
import { NoPermissionErrorComponent } from '@/components/NoPermissionErrorComponent'
import { memberDescriptionQueryOptions, useUpdateMemberDescriptionMutation } from '@/api/memberQueryOptions'
import MemberDescriptionForm from '@/components/form/member/MemberDescriptionForm'

export const Route = createFileRoute(
  '/_auth/member_/$memberUuid/descriptions',
)({
  component: MemberDescriptionsComponent,
  errorComponent: ({ error }) => {
    if (error instanceof NoPermissionError) {
      return (
        <NoPermissionErrorComponent error={error}></NoPermissionErrorComponent>
      )
    }
    return <ErrorComponent error={error}></ErrorComponent>
  },
})

function MemberDescriptionsComponent() {
  const params = Route.useParams()

  const descriptionPublicQuery = useSuspenseQuery(
    memberDescriptionQueryOptions(params.memberUuid, 'public'),
  )

  const descriptionPrivateQuery = useSuspenseQuery(
    memberDescriptionQueryOptions(params.memberUuid, 'private'),
  )

  const updateDescriptionMutation = useUpdateMemberDescriptionMutation(params.memberUuid)

  const descriptionPublicForm = MemberDescriptionForm('public', descriptionPublicQuery, updateDescriptionMutation)
  const descriptionPrivateForm = MemberDescriptionForm('private', descriptionPrivateQuery, updateDescriptionMutation)

    return (
      <>
      {descriptionPublicForm} 
      {descriptionPrivateForm}     
      </>
    )
}
